/**
 * Where the layout changes shape.
 *
 * One source for these numbers so a component and the shell can never disagree
 * about what "mobile" means — the sidebar width and the content offset used to
 * be duplicated literals in two files, which is exactly how that drifts.
 */
export const BREAKPOINTS = {
  /** Phones. Below this the sidebar becomes an off-canvas drawer. */
  mobile: 768,
  /** Tablets and small laptops — layouts may drop columns but keep the rail. */
  tablet: 1024,
};

export const MEDIA = {
  mobile: `(max-width: ${BREAKPOINTS.mobile - 1}px)`,
  tablet: `(max-width: ${BREAKPOINTS.tablet - 1}px)`,
};

/** Sidebar geometry, shared by the drawer and the content offset. */
export const SIDEBAR_WIDTH = {
  expanded: 280,
  collapsed: 80,
};
